module.exports = __webpack_public_path__ + "static/swipe-4934ada08d14ab9e105c2999631b482f.gif";